import { Container, Row, Col, Image } from 'react-bootstrap';
import LineImage from 'assets/images/review-p.png';
import cns from 'classnames';
import styles from './landing.module.scss';

export default function ReviewTrust() {
  return (
    <div className={cns(styles.reviewAndTrustWrapper)}>
      <Container>
        <div className="pt-5 text-center text-white">
          <h4>Review & Trust</h4>
          <p className="w-75 m-auto">
            The CAP60 Solution helps nonprofit organizations manage all aspects
            of agency-wide data
          </p>
        </div>
        <Row className="my-5 align-items-start">
          <Col md={3}>
            <div className="text-md-right mt-4">
              <h4 className="textGreen mb-3">40 States</h4>
              <h6 className="text-white mb-0 font-s1 font-weight-normal pl-3">
                Agencies in 40 states choose CAP60
              </h6>
            </div>
          </Col>
          <Col md={6} className="d-none d-md-flex">
            <Image src={LineImage} />
          </Col>
          <Col md={3}>
            <div className="">
              <h4 className="textGreen mt-4">1 M Clients Served </h4>
              <h6 className="text-white mb-0 font-s1 font-weight-normal pr-3">
                More then 1.2 million served by CAP60 agencies
              </h6>
            </div>
          </Col>
        </Row>

        <Row className="mt-5 justify-content-center">
          <Col md={6}>
            <div className="text-center text-white py-5">
              <h4>Grant Reporting Made Easy</h4>
              <p>
                Tracking and reporting ALL of your funding sources can be done
                easily. We have more than 500 reports in the system. Local,
                County, State, and private – no matter the source – CAP60 does
                the job. Still not seeing the one you need? Easy, we’ll make it
                for you. Customized reports mean that you always have the ones
                you want. Self-sufficiency, outcomes, and productivity: we can
                help you track it all
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
